import axios from 'axios'
import { messageAuthIdentity, messageAuthSession } from '@/utils/messageAuthSession'

const value = response => {
  if (response.data?.code !== 200) throw new Error(response.data?.message || '消息请求失败')
  return response.data.data
}
export const messageApi = {
  isCurrentScope: scope => scope === messageAuthIdentity(),
  config: signal => axios.get('/api/messages/config', options(signal)).then(value),
  streamTicket: signal => axios.post('/api/messages/stream-ticket', {}, options(signal)).then(value),
  list: (params, signal) => axios.get('/api/messages', { ...options(signal), params }).then(value),
  states: (ids, signal) => axios.get('/api/messages/states', { ...options(signal), params: { ids: ids.join(',') } }).then(value),
  summary: signal => axios.get('/api/messages/summary', options(signal)).then(value),
  detail: (id, signal) => axios.get(`/api/messages/${id}`, options(signal)).then(value),
  read: (id, signal) => axios.post(`/api/messages/${id}/read`, {}, options(signal)).then(value),
  markAllRead: (throughMessageId, signal) => axios.post('/api/messages/markAllRead', { throughMessageId }, options(signal)).then(value),
  adjacent: (id, params, signal) => axios.get(`/api/messages/${id}/adjacent`, { ...options(signal), params }).then(value),
  target: (id, signal) => axios.get(`/api/messages/${id}/target`, options(signal)).then(value),
}
const options = signal => ({ signal, messageSession: messageAuthSession() })
